var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useState } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { accountApi } from '../../api/common/account';
import { formattedToday } from '../../utils/PerkOptionsUtil';
import { ChallengesContext } from './challenges-context';
import { DrawerEventListeners } from '../../utils/DrawerEventUtils';
var InfoRewardsContext = createContext(null);
var InfoRewardsProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(null), rewardsInfo = _b[0], setRewardsInfo = _b[1];
    var _c = useState(false), hasError = _c[0], setHasError = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(true), isRewardsLoading = _e[0], setIsRewardsLoading = _e[1];
    var _f = React.useState([]), rewardList = _f[0], setRewardList = _f[1];
    var isBlendedRewardsEnabled = ['1', 1].includes(useConfigService('ENABLE_BLENDED_REWARDS'));
    var _g = React.useContext(ChallengesContext), challenge = _g.challenge, isChallengeLoading = _g.isChallengeLoading;
    var finishRewardsLoad = React.useCallback(function (infoData, challengeTemp) {
        var _a;
        if (infoData) {
            var nonProgramPerks = infoData === null || infoData === void 0 ? void 0 : infoData.nonProgramPerks;
            var previousYearPerks = infoData === null || infoData === void 0 ? void 0 : infoData.previousYearPerks;
            var programPerks = (_a = infoData === null || infoData === void 0 ? void 0 : infoData.program) === null || _a === void 0 ? void 0 : _a.tiers;
            var startingList = __spreadArray(__spreadArray(__spreadArray([], previousYearPerks, true), programPerks, true), nonProgramPerks, true);
            if (nonProgramPerks !== undefined && previousYearPerks !== undefined) {
                var fullRewardsList = startingList
                    .filter(function (reward) {
                    var _a, _b, _c;
                    return ['ACTIVE', 'UNCLAIMED'].includes((_a = reward.perkStatus) !== null && _a !== void 0 ? _a : (_c = (_b = reward.tierPerks) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.perkStatus);
                })
                    .map(function (perk) {
                    var _a;
                    return (__assign(__assign({ tierPerks: [perk] }, (_a = perk.tierPerks) === null || _a === void 0 ? void 0 : _a[0]), perk));
                });
                var tierPerks = fullRewardsList.filter(function (reward) { return reward.perkStatus === 'ACTIVE'; });
                var unclaimedPerks = fullRewardsList.filter(function (reward) { return reward.perkStatus === 'UNCLAIMED'; });
                var rewards = tierPerks.sort(function (ap, bp) {
                    var daysLeftA = ap.daysLeft !== undefined ? ap.daysLeft : Infinity;
                    var daysLeftB = bp.daysLeft !== undefined ? bp.daysLeft : Infinity;
                    return daysLeftA - daysLeftB;
                });
                var tempPerksActivatedToday_1 = rewards
                    .filter(function (reward) {
                    return reward.activationTime === formattedToday &&
                        reward.offerType === 'PERK';
                })
                    .reverse();
                var remainingRewards = rewards.filter(function (reward) { return !tempPerksActivatedToday_1.includes(reward); });
                if (challenge && Object.keys(challengeTemp).length > 0) {
                    setRewardList(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], tempPerksActivatedToday_1, true), [
                        challengeTemp
                    ], false), unclaimedPerks, true), remainingRewards, true));
                }
                else {
                    setRewardList(__spreadArray(__spreadArray(__spreadArray([], tempPerksActivatedToday_1, true), unclaimedPerks, true), remainingRewards, true));
                }
            }
        }
        else if (challenge && Object.keys(challengeTemp).length > 0) {
            setRewardList([challengeTemp]);
        }
        setIsLoading(false);
    }, []);
    var getPerksInfoRewardsData = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var infoData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRewardsLoading(function () { return true; });
                    return [4 /*yield*/, accountApi
                            .perksInfoRewardsDetails()
                            .then(function (data) {
                            if ((data === null || data === void 0 ? void 0 : data.errors) || !(data === null || data === void 0 ? void 0 : data.customerAccountId)) {
                                return setHasError(true);
                            }
                            return data;
                        })];
                case 1:
                    infoData = _a.sent();
                    setRewardsInfo(function () { return infoData; });
                    setIsRewardsLoading(function () { return false; });
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var refreshRewards = React.useCallback(function () {
        setHasError(false);
        setIsLoading(function () { return true; });
        getPerksInfoRewardsData();
    }, []);
    DrawerEventListeners.useInfoRewardsActivateListeners(refreshRewards);
    React.useEffect(function () {
        if (!isChallengeLoading && !isRewardsLoading) {
            finishRewardsLoad(rewardsInfo, challenge);
        }
    }, [isChallengeLoading, isRewardsLoading]);
    return (React.createElement(InfoRewardsContext.Provider, { value: React.useMemo(function () { return ({
            hasError: hasError,
            setHasError: setHasError,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            rewardsInfo: rewardsInfo,
            getPerksInfoRewardsData: getPerksInfoRewardsData,
            setRewardsInfo: setRewardsInfo,
            rewardList: rewardList,
            setRewardList: setRewardList,
            finishRewardsLoad: finishRewardsLoad,
            refreshRewards: refreshRewards,
            isBlendedRewardsEnabled: isBlendedRewardsEnabled,
        }); }, [isLoading, rewardList, isBlendedRewardsEnabled]) }, children));
};
export { InfoRewardsProvider, InfoRewardsContext };
